import axios from "axios";
import { MessageBox, Message } from "element-ui";
// import store from "@/store";
import { getToken, removeToken } from "./auth";
import router from "@/router";
// create an axios instance
// console.log(process.env.VUE_APP_BASE_API,'url');
// console.log(111111111)
const service = axios.create({
  baseURL: 'https://www.cmubj.com:8004', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if (getToken()) {
    //   // let each request carry token
    //   // ['Authorization'] is a custom headers key
    //   // please modify it according to the actual situation
    //   config.headers["Authorization"] = getToken();
    // } 
    // else {
    //   router.replace({
    //     path: "/login"
    //   });
    //   return;
    // }

    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// const timeout_process = () => {
//   store.dispatch("user/resetToken").then(() => {
//     router.replace({
//       path: "/login"
//     });
//   });
// };

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res) {
      switch (res.code) {
        //登录成功
        case 200:
          break;
        //token失效
        case 666:
          Message({
            message: "登录状态过期，请重新登录",
            type: "error",
            duration: 2 * 1000
          });
          // timeout_process();
          break;
        //其他错误信息
        default:
          Message({
            message: res.message || "Error",
            type: "error",
            duration: 2 * 1000
          });
          break;
      }
    }
    return res;
  },
  error => {
    Message({
      message: error || "Error",
      type: "error",
      duration: 3 * 1000
    });
    console.log("err " + error); // for debug

    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/api/request.js